import UniversalInput from "components/uiComponents/UniversalInput";
import { useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import {
  setCursorPositionAC,
  setFunctionValueAC,
  setShowDropdownAC,
  setSortedValueAC,
} from "store/actions/condition";
import { ObjectFilterByKeys } from "utils/helpers";
import { FormulaTree } from "utils/services";
import { functionParserService } from "utils/services/functionParser.service";
import SelectFormulaDropdown from "../FormulaComponents/FormulaSelect/SelectFormulaDropdown";
import Tag from "components/uiComponents/Tag";
import { getBounding } from "utils/elementExt";

const SimpleFormulaInputMode = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const inputRef = useRef(null);

  const conditionalButtons = useSelector(
    (state) => state.condition.conditionalButtons
  );
  const showDropdown = useSelector((state) => state.condition.showDropdown);
  const functionValue = useSelector((state) => state.condition.functionValue);
  const dropdownData = useSelector((state) => state.condition.dropdownData);
  const currentSortedValue = useSelector(
    (state) => state.condition.currentSortedValue
  );
  const currentPosition = useSelector(
    (state) => state.condition.currentPosition
  );

  const filteredDropDownData = useMemo(() => {
    return ObjectFilterByKeys({
      object: dropdownData,
      keys: [FormulaTree.NODE_TYPES.Variable],
    });
  }, [dropdownData]);

  const setShowDropdownHandler = (boolValue) => {
    dispatch(setShowDropdownAC(boolValue));
  };

  const onChangeFunctionHandler = (value) => {
    if (!functionParserService.isAllSquareBracketsClosed(value)) {
      setShowDropdownHandler(true);
    } else {
      setShowDropdownHandler(false);
    }
    dispatch(setFunctionValueAC(value));
  };

  const onChangeCursorPositionHandler = (event) => {
    dispatch(setCursorPositionAC(event.target.selectionEnd));
    if (showDropdown) {
      const sortedValue = functionParserService.getUnclosedVariableValue(
        functionValue,
        event.target.selectionEnd
      );
      dispatch(setSortedValueAC(sortedValue));
    }
  };

  const setItemHandler = (item) => {
    const updateString = functionParserService.insertString({
      insertString: item.label,
      initialString: functionValue,
      cursorIndex: currentPosition,
      replaceString: currentSortedValue,
      characterEndedString: "]",
    });
    dispatch(setFunctionValueAC(updateString));
    dispatch(setSortedValueAC(null));
    dispatch(setCursorPositionAC(updateString.length));
    setShowDropdownHandler(false);
  };

  const onTagClickHandler = (item) => {
    const updateString = functionParserService.insertString({
      insertString: item.label,
      initialString: functionValue,
      cursorIndex: currentPosition,
      replaceString: currentSortedValue,
      characterEndedString: "",
    });
    dispatch(setFunctionValueAC(updateString));
    dispatch(setSortedValueAC(null));
    dispatch(setCursorPositionAC(updateString.length));
  };

  const onClearSearchHandler = () => {
    dispatch(setFunctionValueAC(""));
    dispatch(setShowDropdownAC(false));
  }

  const renderDropDown = () => {
    const currentInputPosition = inputRef.current
      ? getBounding(inputRef.current)
      : {};

    return (
      <>
        {showDropdown && (
          <SelectFormulaDropdown
            onSelectItem={setItemHandler}
            searchValue={currentSortedValue}
            currentInputPosition={currentInputPosition}
            dropdownData={filteredDropDownData}
            isFullWidth
          />
        )}
      </>
    );
  };

  return (
    <>
      <div>
        <div className="conditional-modal__input">
          <span className="conditional-modal__input-label">{t('function')}</span>
          <div ref={inputRef}>
            <UniversalInput
              value={functionValue}
              onChangeValue={onChangeFunctionHandler}
              onClick={onChangeCursorPositionHandler}
              onKeyUp={onChangeCursorPositionHandler}
              onClearSearch={onClearSearchHandler}
              isClearButtonActive
            />
            
          </div>

          {renderDropDown()}
        </div>
        <div className="conditional-modal__tag-wrappers">
          {conditionalButtons.map((item) => {
            return (
              <div onClick={() => onTagClickHandler(item)} key={item.name}>
                <Tag title={item.name} type={"primary"} />
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default SimpleFormulaInputMode;
